import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Link } from 'react-router-dom';
import { Button, Modal, Collapse } from 'reactstrap';
import { InputSelect } from '../Forms/Input';
import { BankTransferInstructions } from '../PageUserDashboard/TopUp';
import {convertToRupiah} from '../../utils';
import { ASSET_IMAGE } from '../../config'

const PaymentConfirmLink = ({id, invoiceNumber, url, paymentMethod, onRedirectXendit}) => (
  id?
  (
    paymentMethod === 'virtual_account'?
      <Button className="payment-confirm" onClick={()=>onRedirectXendit(url)}>Payment Confirmation</Button>
    // :<Button className="payment-confirm"> <Link to={`/payment_confirmation/${invoiceNumber}`}>Payment Confirmation</Link></Button>
    :<Link className="payment-confirm btn btn-secondary" to={`/payment_confirmation/${invoiceNumber}`}>Payment Confirmation</Link>
  )
  :null
)

const BankAccountContainer = ({ accountNumber, accountName, bankName }) => (
  <div className="bank-content">
    <div className="bank-icon">
      <KickImage className="img-responsive" src={`${ASSET_IMAGE}/email/${bankName.toLowerCase()}.png`} alt={bankName} />
    </div>
    <div className="text-desc2 third-modal">
      <p>{accountNumber}</p>
      <p>{accountName}</p>
    </div>
  </div>
)

const getTotalAmountRupiah = (total_amount) => (
  convertToRupiah(parseInt(total_amount))
  )

  class ModalTopup3 extends React.Component{
    constructor(props){
      super(props)
      this.state={
        collapse: false
      }
      this._handleOnToggleCollapse = this._handleOnToggleCollapse.bind(this);
    }

    _handleOnToggleCollapse(){
      this.setState({
        collapse: !this.state.collapse
      })
    }
    render(){
      if(this.props.dataTopUp === null)
      return null;
      const { id, payment_method, invoice_number, invoice_url, total_amount, status_code, expiry } = this.props.dataTopUp;
      return(
        <Modal
        modalClassName="modal-topup"
        isOpen={this.props.isOpen}
        toggle={this.props.onToggle}
        >
        <div className="topup-header">
          <p>TOP UP</p>
        </div>
        <div className="topup-content third-modal">
          <div className="third-modal-content">
            <div className="wrap-topup-amount">
              <div className="topup-amount">
                {
                  status_code===200?
                  <p>{getTotalAmountRupiah(total_amount)}</p>
                  :null
                }
              </div>
            </div>
            <p className="text-center text-invoice">INVOICE: <strong>{invoice_number}</strong></p>
            <div className="text-desc2 third-modal">
              <p>Bank Transfer (ATM/nternet/Mobile Banking)</p>
            </div>
            <div className="wrap-collapse">
              <Button className="topup-collapse" onClick={this._handleOnToggleCollapse}>Instructions
                <i className={this.state.collapse?"fa fa-caret-up":"fa fa-caret-down"} style={{marginLeft: '.5rem'}}></i>
              </Button>
            </div>
            <Collapse className="display-collapse" isOpen={this.state.collapse}>
              <BankTransferInstructions totalAmount={total_amount}/>
            </Collapse>
            {/* <div className="dropdown-topup third-modal">
              <InputSelect
              name="paymentMethod"
              // value={state.paymentMethod}
              // onChange={this.props.onTextChange}
              // options={payment_method}
              />
            </div> */}
            <div className="text-desc2 third-modal">
                <p>We have received your request to Top Up your Kick Wallet.</p>
                <p>We are waiting for your payment, please transfer the specified amount to:</p>
            </div>
            <div style={{overflowY: 'scroll', height: '180px'}}>
            {
              status_code===200 && this.props.dataTopUp.account_banks.length>0?
              this.props.dataTopUp.account_banks.map(bank =>
                  <BankAccountContainer
                  key={bank.id}
                  accountNumber={bank.account_number}
                  accountName={bank.account_name}
                  bankName={bank.bank_name}
                  />
                )
                :
                <BankAccountContainer
                accountNumber={this.props.accountNumber}
                accountName={this.props.accountName}
                bankName="bca"
                />
              }
            </div>
            <div className="text-desc2">
              <div className="expiry-placeholder">
                <p>Expiry: {expiry}</p>
              </div>
            </div>
          </div>
          <div className="wrap-button-text">
            <PaymentConfirmLink
              id={id}
              invoiceNumber={invoice_number}
              url={invoice_url}
              paymentMethod={payment_method}
              onRedirectXendit={url => window.location = url}
              />
          </div>
        </div>
      </Modal>

    )
  }
}

export default ModalTopup3;
